export const environment = {
  production: false,
  apiUrl: 'https://pro-be.tsin.ca/api',
  apiUrl2: 'https://pro-be.tsin.ca/api',
  mmiBackendUrl: 'https://mmi.api.tsin.ca/api', // TODO: Update with actual production MMI backend URL
  userBaseUrl: 'https://auth.tsin.ca/api',
  userMgtUrl: 'https://portal1.tsin.ca/login/pro',
  authBaseUrl: 'https://zxkbbj3pcy.us-east-1.awsapprunner.com/api',
  paymentUrl: 'https://payment-prod.tsin.ca',
  learningBaseUrl: 'http://tsin2024-learningbackend-dev-env.eba-kawpeksu.ca-central-1.elasticbeanstalk.com/api',
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  oldApiUrl: 'https://portalstage-be.tsin.ca/api/',
  jiraLink: 'https://tsin.atlassian.net/servicedesk/customer/portal/8',
  externalApiUrl: 'https://ukammvdjzt.us-east-1.awsapprunner.com/api',
  /** B4 — Screener Queue feature flag (disabled in production until full rollout).
   *  Drapeau de fonctionnalité — désactivé en production jusqu'au déploiement complet. */
  featureScreenerQueue: true,
  /** Phase B — Kye AI Agents read-only UI (disabled in production until full rollout).
   *  Phase B — Interface lecture seule des agents IA Kye (désactivée en production). */
  featureKyeAgents: true,
  /** KYE-A-08 — SUPER_ADMIN-only PII redaction admin tool (disabled in prod until full rollout).
   *  KYE-A-08 — Outil d'administration de rédaction de RPI (désactivé en production jusqu'au déploiement complet). */
  featureKyePiiRedaction: true,
  /** KYE — Admin API test console (disabled in production until full rollout).
   *  KYE — Console d'essai de l'API Kye (désactivée en production jusqu'au déploiement complet). */
  featureKyeAdminConsole: true,
  /** KYE — Admin bulk screening. Disabled in production pending stage
   *  sign-off — unlike the other KYE flags above, this one triggers agent
   *  runs across potentially many applications at once, so it's rolled out
   *  deliberately rather than defaulting on with the rest.
   *  KYE — Dépistage groupé par un administrateur. Désactivé en production
   *  en attendant la validation en stage. */
  featureKyeBulkRun: false,
  /** "Review Submitted Applications" (application-review) kill switch — on in
   *  production, matching this feature's always-on behavior before this flag
   *  existed.
   *  Interrupteur « Réviser les candidatures soumises » — actif en production. */
  featureApplicationReview: true,
  /** Reopen a finalized decision for re-review. Disabled in production
   *  pending stage sign-off — mutates already-finalized, potentially
   *  candidate-facing data, so rolled out deliberately.
   *  Rouvrir une décision finalisée. Désactivé en production. */
  featureReopenDecision: true,
  /** Community pathway (practice option) — applicant page, its landing redirect
   *  and the Screener Queue Community Stream column. See environment.ts.
   *  Volet communautaire — page du candidat, redirection et colonne de la file. */
  featureCommunityPathway: false,
};
